import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Button, { ButtonProps } from '../components/button';

interface ButtonElement extends Element {
  props: Element['props'] & ButtonProps;
}

const button: Processor<ButtonElement> = {
  priority: 15,
  name: 'button',
  test: ({ node }) =>
    node?.component === 'a' && !!node?.props?.className && node.props.className.includes('wp-element-button'),
  processor: ({ node }) => {
    node.component = Button as ComponentType;

    return node;
  }
};

export default button;
